import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m3 16 4 4 4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 20V4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { x: "15", y: "4", width: "4", height: "6", ry: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 20v-6h-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 20h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowDown01";
const ArrowDown01 = memo(themed(Icon));
export {
  ArrowDown01
};
//# sourceMappingURL=arrow-down-0-1.js.map
